import React, { useState, useEffect, useContext } from 'react';
import { Link } from 'react-router-dom';
import PortalNav from '../header/portal_nav';
import Notifications from '../header/notifications';
import { useChain, useSpringRef } from '@react-spring/web';
import Context from '../../utils/context';
import SimpleAvatar from '../ui_kit/utilities/simple_avatar';

export default function MemberPlatformHeader({ hideLinks = false }) {
  const context = useContext(Context);
  const actioncable = context.actioncable;
  const [navOpen, setNavOpen] = useState(false);
  const viewport = context.viewport;
  const isMobile = viewport.getIsMobile();
  const [headerSticky, setHeaderSticky] = useState(false);
  const navItemsAnimation = useSpringRef();

  useChain(navOpen ? [navItemsAnimation] : [navItemsAnimation], [0.2]);

  const [unreadNotificationCount, setUnreadNotificationCount] = useState(
    context.auth.isLoggedIn() && context.auth.getCurrentUser().current_profile.unread_notification_count
  );

  const onReceived = (data) => {
    if (data.type === 'unread_notification_count') {
      context.auth.setUnreadNotificationCount(data.value);
      setUnreadNotificationCount(data.value);
    }
  };

  useEffect(() => {
    let subscriptionId = null;
    if (context.auth.isLoggedIn()) {
      subscriptionId = actioncable.subscribe(
        'ProfileChannel',
        { id: context.auth.getCurrentUser().profile_id },
        onReceived
      );
    }

    return () => {
      if (subscriptionId) {
        actioncable.unsubscribe(subscriptionId);
      }
    };
  }, []);

  let navigationItems = [];
  if (context.auth.isLoggedIn()) {
    let procedureFilter = '';
    if (context.auth.getCurrentUser().current_profile.surgeries_or_treatments.length > 0) {
      procedureFilter = objToQueryString({
        procedures: context.auth.getCurrentUser().current_profile.surgeries_or_treatments[0],
      });
    }

    if (context.auth.getCurrentUser().current_profile.procedures.length > 0) {
      navigationItems = [
        {
          props: {
            to: `/member/profile/${context.auth.getCurrentUser().slug}`,
          },
          title: 'Profile',
          icon: 'https://patientpartner-images2.s3.us-west-1.amazonaws.com/website/icons/profile.svg',
          pendoTag: 'nav-dropdown-profile',
        },
        {
          props: {
            to: `/partners?${procedureFilter}`,
          },
          title: 'Find a mentor',
          icon: 'https://patientpartner-images2.s3.us-west-1.amazonaws.com/website/icons/community.svg',
          pendoTag: 'nav-dropdown-community',
        },
        {
          props: {
            to: '/member/settings',
          },
          title: 'Settings',
          icon: 'https://patientpartner-images2.s3.us-west-1.amazonaws.com/website/icons/settings.svg',
          pendoTag: 'nav dropdown - settings',
        },
        {
          onclick: 'logout',
          props: {},
          title: 'Log out',
          icon: 'https://patientpartner-images2.s3.us-west-1.amazonaws.com/website/platform/log+out.svg',
          color: 'red',
          pendoTag: 'nav dropdown - logout',
        },
      ];
    } else {
      navigationItems = [
        {
          props: {
            to: '/member/settings',
          },
          title: 'Settings',
          icon: 'https://patientpartner-images2.s3.us-west-1.amazonaws.com/website/icons/settings.svg',
          pendoTag: 'nav dropdown - settings',
        },
        {
          onclick: 'logout',
          props: {},
          title: 'Log out',
          icon: 'https://patientpartner-images2.s3.us-west-1.amazonaws.com/website/platform/log+out.svg',
          color: 'red',
        },
      ];
    }
  }

  if (
    context.auth.isLoggedIn() &&
    !context.auth.getCurrentUser().is_super_user &&
    context.auth.getCurrentUser().true_user &&
    context.auth.getCurrentUser().true_user.is_super_user
  ) {
    navigationItems.push({
      onclick: 'stopImpersonating',
      title: 'Stop Impersonating',
      color: 'red',
    });
  }

  let homeLogoRedirect = '/';
  if (context.auth.isLoggedIn()) {
    homeLogoRedirect = '/member/conversations';
  }

  return (
    <header
      className={`${headerSticky === true ? 'nosticky' : ''} platform-header member_platform_header`}
      id='hdr-content'
    >
      <div className='container-fluid'>
        <div className='header-outr row'>
          <div className={`${isMobile ? 'col-4' : 'col-2'}`}>
            <div className='hdr-logo'>
              {window.location.pathname.includes('/member/join') ? (
                <img
                  alt='logo'
                  id='logo'
                  src='https://patientpartner-images2.s3.us-west-1.amazonaws.com/website/logos/svg/pp-logo.svg'
                  data-gtm-click-label='Nav Logo'
                />
              ) : (
                <Link data-pendo-tag='navigation - logo' to={homeLogoRedirect}>
                  <img
                    alt='logo'
                    id='logo'
                    src='https://patientpartner-images2.s3.us-west-1.amazonaws.com/website/logos/svg/pp-logo.svg'
                    data-gtm-click-label='Nav Logo'
                  />
                </Link>
              )}
            </div>
          </div>
          <div className={`text-center ${isMobile ? '' : 'col-7'}`}>
            <div style={{ marginRight: '0px' }} className='header-innr'>
              {!hideLinks && (
                <>
                  <div className='col'>
                    <Link to='/member/conversations'>
                      <img
                        alt='messages'
                        id='messages'
                        src='https://patientpartner-images2.s3.us-west-1.amazonaws.com/website/newsfeed/icon+16/messages.svg'
                        data-pendo-tag='navigation-conversations'
                      />
                    </Link>
                  </div>
                  <div style={unreadNotificationCount > 0 ? { marginRight: '10px' } : {}} className='col'>
                    {isMobile ? (
                      <Link
                        data-pendo-tag='navigation-notifications'
                        to={
                          isMobile
                            ? `/member/profile/${context.auth.getCurrentUser().slug}/activity?scrollto=true`
                            : `/member/profile/${context.auth.getCurrentUser().slug}/activity`
                        }
                      >
                        <Notifications embedded unreadNotificationCount={unreadNotificationCount} />
                      </Link>
                    ) : (
                      <Notifications
                        data-pendo-tag='navigation-notifications'
                        unreadNotificationCount={unreadNotificationCount}
                      />
                    )}
                  </div>
                </>
              )}

              <div className='col de-pad'>
                <PortalNav profileCircleElement={<SimpleAvatar />} navigationItems={navigationItems} />
              </div>
            </div>
            <div className='navbar-header'>
              <nav
                className='navbar navbar-expand-md navbar-light sidenav'
                id='mySidenav'
                style={{ right: navOpen ? '0px' : '-100%' }}
              >
                {isMobile === true && <Link onClick={() => setNavOpen(false)} to='/'></Link>}
              </nav>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
}
